import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaPaperPlane,
  FaSpinner,
  FaCheckCircle,
} from "react-icons/fa";

const ContactWithForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      _subject: `New Contact from ${formData.name}`,
      _template: "table",
    };

    try {
      const response = await fetch("https://formsubmit.co/ajax/shardaiti2014@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setSubmitStatus({ type: "success", message: "Message sent! We'll get back to you soon." });
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        throw new Error("Failed to send");
      }
    } catch (error) {
      setSubmitStatus({ type: "error", message: "Something went wrong. Please try again or call us." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="w-full bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-md">
            <FaEnvelope className="h-5 w-5 text-green-600" />
            <span className="text-sm font-semibold text-gray-700">Get in Touch</span>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900 md:text-4xl">
            Contact <span className="text-green-600">Us</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-gray-600">
            Have questions? We're here to help. Send us a message and we'll respond promptly.
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-2">
          <div className="space-y-6">
            <div className="rounded-2xl bg-white p-6 shadow-md transition hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-green-100 p-3 text-green-600">
                  <FaMapMarkerAlt className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">Address</h3>
                  <p className="text-gray-600">
                    Village - Kushnow, Post - Bhaupur<br />
                    District - Jaunpur, Pin - 222136<br />
                    Uttar Pradesh
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-md transition hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-orange-100 p-3 text-orange-500">
                  <FaPhoneAlt className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">Phone</h3>
                  <p className="text-gray-600">+91 9956808612<br />+91 8090586416</p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-md transition hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-green-100 p-3 text-green-600">
                  <FaEnvelope className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">Email</h3>
                  <p className="text-gray-600 break-all">shardaiti2014@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-md transition hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-orange-100 p-3 text-orange-500">
                  <FaClock className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">Working Hours</h3>
                  <p className="text-gray-600">Mon – Sat: 9:00 AM – 6:00 PM<br />Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-2xl bg-white p-6 shadow-md md:p-8">
            <h3 className="mb-6 text-2xl font-bold text-gray-800">Send a Message</h3>

            {submitStatus.message && (
              <div className={`mb-4 rounded-lg p-3 text-sm flex items-center gap-2 ${
                submitStatus.type === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
              }`}>
                {submitStatus.type === "success" && <FaCheckCircle />}
                {submitStatus.message}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Message *</label>
                <textarea
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-green-600 to-orange-500 px-6 py-3 font-semibold text-white shadow-md transition hover:shadow-lg disabled:opacity-50"
              >
                {isSubmitting ? (
                  <><FaSpinner className="animate-spin" /> Sending...</>
                ) : (
                  <><FaPaperPlane /> Send Message</>
                )}
              </button>
            </form>
          </div>
        </div>
        <div className="mt-12 overflow-hidden rounded-2xl shadow-lg">
          <iframe
            title="Location Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28676.913710979653!2d82.682943!3d25.751876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39918d9b8b1b6b6b%3A0x6c2b8c5a5b5b5b5b!2sJaunpur%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1699876543210!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            className="transition duration-500 hover:scale-105"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactWithForm;